import { render } from "./VoucherAssignTab.vue?vue&type=template&id=05c18e8c&scoped=true"
import script from "./VoucherAssignTab.vue?vue&type=script&lang=js"
export * from "./VoucherAssignTab.vue?vue&type=script&lang=js"

import "./VoucherAssignTab.vue?vue&type=style&index=0&id=05c18e8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c18e8c"]])

export default __exports__